const second = 1 * 1000
const minute = 60 * second
const hour = 60 * minute
const day = 24 * hour

// RootsTech happens in Salt Lake City, so the conference dates are facts about that
// timezone. Format them there rather than in the viewer's local zone, or the MST-anchored
// end timestamp rolls into the next day for anyone at or east of UTC.
const CONFERENCE_TIME_ZONE = 'America/Denver'

export { second, minute, hour, day, CONFERENCE_TIME_ZONE }
